import {HttpHeaders} from "@angular/common/http";

export const emptyHttpHeaders = new HttpHeaders({});

export const jsonPathHeaders = new HttpHeaders({ 'Content-Type': 'application/json-patch+json' });

export const octetStreamHeaders = new HttpHeaders({ Accept: "application/octet-stream" });

export const downloadImageHeaders = new HttpHeaders({ 'Accept': 'image/jpeg' });

export const downloadVideoHeaders = new HttpHeaders({ 'Accept': 'application/octet-stream' });

export const downloadFileHeaders = new HttpHeaders({ 'Content-Type': 'application/octet-stream' });
